import React, { Component } from 'react';
import classNames from 'classnames';
import Icon from '../../common/components/Icon';

const Toast = ({ type, text, onClose }) => {
	const classes = classNames('toast', `toast--${type}`);

	return (
		<div className={classes}>
			{text}
			<div className="toast__close" onClick={onClose}>
				<Icon icon="cross" />
			</div>
		</div>
	);
};

export default Toast;



// WEBPACK FOOTER //
// ./src/js/Ui/Toast/Toast.jsx